import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 15 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7031 12.2344L7.625 0L0.5 12.2344L7.625 16.5938L14.7031 12.2344ZM7.62241 14.8337L12.674 11.7224L7.62072 2.98796L2.53487 11.7209L7.62241 14.8337ZM14.75 13.6406L7.625 18L0.5 13.6406L7.625 24L14.75 13.6406ZM9.51852 18.6L7.625 19.7585L5.73148 18.6L7.625 21.353L9.51852 18.6Z"
      fill="#ECEDEE"
    />
  </svg>
)
